function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('saito-js/lib/transaction'),
  TransactionType = _require.TransactionType;
var Saito = require('saito-js/saito')["default"];
function getBlockHashAtHeight(_x, _x2) {
  return _getBlockHashAtHeight.apply(this, arguments);
}
function _getBlockHashAtHeight() {
  _getBlockHashAtHeight = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, blockId) {
    var blocks, match;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return app.core.blockchain.getBlocks(Math.max(Number(blockId) + 2, 4), false);
        case 1:
          blocks = _context.v;
          match = (Array.isArray(blocks) ? blocks : []).find(function (block) {
            return Number(block === null || block === void 0 ? void 0 : block.id) === Number(blockId);
          });
          return _context.a(2, match !== null && match !== void 0 && match.hash ? String(match.hash) : null);
      }
    }, _callee);
  }));
  return _getBlockHashAtHeight.apply(this, arguments);
}
function snapshotMempoolFeeTransactionSignatures(_x3) {
  return _snapshotMempoolFeeTransactionSignatures.apply(this, arguments);
}
function _snapshotMempoolFeeTransactionSignatures() {
  _snapshotMempoolFeeTransactionSignatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
    var txs, signatures, i, tx, _tx$total_fees, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.n = 1;
          return Saito.getInstance().getMempoolTxs();
        case 1:
          txs = _context2.v;
          signatures = [];
          i = 0;
        case 2:
          if (!(i < txs.length)) {
            _context2.n = 8;
            break;
          }
          tx = txs[i];
          if (!(Number(tx === null || tx === void 0 ? void 0 : tx.type) === TransactionType.GoldenTicket)) {
            _context2.n = 3;
            break;
          }
          return _context2.a(3, 7);
        case 3:
          _context2.p = 3;
          if (!(BigInt((_tx$total_fees = tx === null || tx === void 0 ? void 0 : tx.total_fees) !== null && _tx$total_fees !== void 0 ? _tx$total_fees : 0) <= 0n)) {
            _context2.n = 4;
            break;
          }
          return _context2.a(3, 7);
        case 4:
          _context2.n = 6;
          break;
        case 5:
          _context2.p = 5;
          _t = _context2.v;
          return _context2.a(3, 7);
        case 6:
          if (tx !== null && tx !== void 0 && tx.signature) {
            signatures.push(String(tx.signature));
          }
        case 7:
          i++;
          _context2.n = 2;
          break;
        case 8:
          return _context2.a(2, signatures);
      }
    }, _callee2, null, [[3, 5]]);
  }));
  return _snapshotMempoolFeeTransactionSignatures.apply(this, arguments);
}
function isGoldenTicketTransaction(tx) {
  var type = tx === null || tx === void 0 ? void 0 : tx.type;
  return type === TransactionType.GoldenTicket || type === 'GoldenTicket' || Number(type) === TransactionType.GoldenTicket;
}
function normalizeHashHex(value) {
  return String(value || '').trim().toLowerCase().replace(/^0x/, '');
}
function goldenTicketTargetHex(tx) {
  if (!(tx !== null && tx !== void 0 && tx.data) || tx.data.length < 32) {
    return null;
  }
  var bytes = tx.data instanceof Uint8Array ? tx.data : new Uint8Array(tx.data);
  return Buffer.from(bytes.slice(0, 32)).toString('hex');
}

/**
 * Verify the block above startBlockId contains one GT for the previous block
 * and includes any fee transactions that were already waiting in the mempool.
 */
function verifyProducedGoldenTicketBlock(_x4, _x5, _x6) {
  return _verifyProducedGoldenTicketBlock.apply(this, arguments);
}
function _verifyProducedGoldenTicketBlock() {
  _verifyProducedGoldenTicketBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, startBlockId, previousBlockHash) {
    var expectedFeeSignatures,
      startId,
      latestBlockId,
      block,
      transactions,
      goldenTickets,
      expectedTarget,
      actualTarget,
      bundled,
      i,
      _args3 = arguments,
      _t2;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          expectedFeeSignatures = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : [];
          startId = Number(startBlockId) || 0;
          _t2 = Number;
          _context3.n = 1;
          return app.blockchain.getLatestBlockId();
        case 1:
          latestBlockId = _t2(_context3.v);
          if (!(latestBlockId <= startId)) {
            _context3.n = 2;
            break;
          }
          console.warn('Explorer: GT block verification failed — chain height unchanged', {
            startBlockId: startId,
            latestBlockId: latestBlockId
          });
          return _context3.a(2, false);
        case 2:
          _context3.n = 3;
          return app.core.blockchain.getBlock(BigInt(latestBlockId), true);
        case 3:
          block = _context3.v;
          transactions = Array.isArray(block === null || block === void 0 ? void 0 : block.transactions) ? block.transactions : [];
          goldenTickets = transactions.filter(isGoldenTicketTransaction);
          if (!(goldenTickets.length !== 1)) {
            _context3.n = 4;
            break;
          }
          console.warn('Explorer: GT block verification failed — expected one golden ticket', {
            count: goldenTickets.length,
            blockId: latestBlockId
          });
          return _context3.a(2, false);
        case 4:
          expectedTarget = normalizeHashHex(previousBlockHash);
          actualTarget = normalizeHashHex(goldenTicketTargetHex(goldenTickets[0]));
          if (!(!expectedTarget || !actualTarget || actualTarget !== expectedTarget)) {
            _context3.n = 5;
            break;
          }
          console.warn('Explorer: GT block verification failed — target mismatch', {
            expectedTarget: expectedTarget,
            actualTarget: actualTarget,
            blockId: latestBlockId
          });
          return _context3.a(2, false);
        case 5:
          if (!(expectedFeeSignatures.length > 0)) {
            _context3.n = 8;
            break;
          }
          bundled = new Set(transactions.map(function (tx) {
            return tx !== null && tx !== void 0 && tx.signature ? String(tx.signature) : '';
          }).filter(Boolean));
          i = 0;
        case 6:
          if (!(i < expectedFeeSignatures.length)) {
            _context3.n = 8;
            break;
          }
          if (bundled.has(expectedFeeSignatures[i])) {
            _context3.n = 7;
            break;
          }
          console.warn('Explorer: GT block verification failed — fee transaction not bundled', {
            signature: expectedFeeSignatures[i],
            blockId: latestBlockId
          });
          return _context3.a(2, false);
        case 7:
          i++;
          _context3.n = 6;
          break;
        case 8:
          return _context3.a(2, true);
      }
    }, _callee3);
  }));
  return _verifyProducedGoldenTicketBlock.apply(this, arguments);
}
module.exports = {
  getBlockHashAtHeight: getBlockHashAtHeight,
  snapshotMempoolFeeTransactionSignatures: snapshotMempoolFeeTransactionSignatures,
  verifyProducedGoldenTicketBlock: verifyProducedGoldenTicketBlock
};